import React, { useState } from "react";
import "./styles.scss";
import Formation, { TypeFormation } from "../../models/Formation";
import Button from "../Button";
import { useNavigate } from "react-router-dom";

const FormationCell: React.FC<
  Formation & {
    sectionType?: string;
    onOpenIndicateursPerformanceModal?: () => void;
    onOpenFinancementsModal?: () => void;
  }
> = ({
  image,
  title,
  description,
  id,
  type,
  sectionType,
  onOpenIndicateursPerformanceModal,
  onOpenFinancementsModal
}) => {
  const navigate = useNavigate();

  return (
    <div className="formation-cell">
      <img
        className="responsive formation-cell-image"
        src={image}
        alt={title}
      />
      <div className="formation-cell-texts">
        <h4>{title}</h4>
        <p>{description}</p>
        {id && sectionType && (
          <>
            <Button
              onClick={() => navigate(`/${sectionType}/${id}`)}
              className="formation-cell-button"
            >
              {type === TypeFormation.FormationSpecifique
                ? "Thématiques de formation"
                : "Programme de formation"}
            </Button>
            <Button
              outline
              onClick={onOpenIndicateursPerformanceModal}
              className="formation-cell-button"
            >
              Indicateurs de performance
            </Button>
            <Button
              outline
              onClick={onOpenFinancementsModal}
              className="formation-cell-button"
            >
              En savoir plus sur les financements
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default FormationCell;
